export enum PaymentEngine {
    NONE = "NONE",
    SHIFT4 = "SHIFT4",
    AUTHNET = "AUTHNET",
    ADYEN = "ADYEN",
    DATACAP = "DATACAP",
    BROADPOSGENERIC = "BROADPOSGENERIC",
}
